import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {
    constructor(
        protected override readonly router: Router,
        protected readonly keycloak: KeycloakService
    ) {
        super(router, keycloak);
    }

    async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const requiredRoles = [];
        const path = route.url[0]?.path;
        if (path === 'admin' || path === undefined) {
            requiredRoles.push('app-admin.administrer', 'app-admin-gpo.administrer');
        }
        else if (path === 'fournisseurs') {
            requiredRoles.push('app-admin.administrer');
        }
        else if (path === 'adherents') {
            requiredRoles.push('app-admin.administrer', 'app-admin-gpo.administrer');
        }
        else if (path === 'cockpit-AD') {
            requiredRoles.push('app-admin.administrer', 'app-admin-gpo.administrer');
        }
        else if (path === 'gestioncomptes') {
            requiredRoles.push('app-admin.administrer', 'app-admin-gpo.administrer');
        }
        else if (path === 'pfa-interne') {
            requiredRoles.push('app-admin.administrer', 'app-admin-gpo.administrer');
        }
        if (this.authenticated) {
            const userRoles: string[] = this.keycloak.getUserRoles();
            const hasRequiredRoles = requiredRoles.some(role => userRoles.includes(role));
            if (!hasRequiredRoles) {
                return this.router.parseUrl('/forbidden');
            }
        }
        else {
            await this.keycloak.login({
                redirectUri: window.location.origin + state.url,
            });
        }
        return this.authenticated;
    }
}
